import client from '@/clients/customer/api-client';

interface AskSupportPayload {
  email: string;
  company: string;
  contact_person: string;
  phone?: string;
  'g-recaptcha-response'?: string;
}

export const askSupport = (data: AskSupportPayload, headers: any) =>
  client.post('/ask-support', data, { headers });
